import { db } from '@/database/db';
import type { HCWCategory } from '@/types/hcw';

export async function getHCWCategories(): Promise<HCWCategory[]> {
  return db.hcw_categories.orderBy('sortOrder').toArray();
}

export async function getActiveHCWCategories(): Promise<HCWCategory[]> {
  return db.hcw_categories
    .orderBy('sortOrder')
    .filter((cat) => cat.active)
    .toArray();
}

export async function getHCWCategory(code: string): Promise<HCWCategory | undefined> {
  return db.hcw_categories.get(code);
}

// Export as a single object for easier imports
export const metadataStorage = {
  getAllHCWCategories: getHCWCategories,
  getActiveHCWCategories,
  getHCWCategory,
};
